import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, vModelSelect as _vModelSelect, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, vShow as _vShow, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "task-details"
}
const _hoisted_6 = { class: "container row m-0 p-1" }
const _hoisted_7 = { class: "form-group col-12 mt-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Visit Task ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Non Visit Task ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", {
  for: "task-name",
  class: "me-2"
}, "Caregiver/Employee:", -1 /* HOISTED */)
const _hoisted_11 = { class: "bold" }
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Agency:", -1 /* HOISTED */)
const _hoisted_14 = {
  key: 0,
  class: "form-group col-12 col-md-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Date ", -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_17 = { class: "input-group date datepickerInput" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_20 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_21 = { class: "col-12 col-md-auto form-group" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Date ", -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_24 = { class: "input-group flex-nowrap" }
const _hoisted_25 = { class: "input-group date datepickerInput" }
const _hoisted_26 = ["value"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_28 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "w-10" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_30 = { class: "input-group date datepickerInput" }
const _hoisted_31 = ["value"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_33 = {
  key: 2,
  class: "form-group col-3"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "branch" }, [
  /*#__PURE__*/_createTextVNode(" Branch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger ms-1" }, "*")
], -1 /* HOISTED */)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "null" }, "Select Branch", -1 /* HOISTED */)
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_39 = { class: "form-group col-10 col-md-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "shift-length" }, " Shift Length ", -1 /* HOISTED */)
const _hoisted_41 = ["disabled"]
const _hoisted_42 = ["value"]
const _hoisted_43 = {
  key: 3,
  class: "col-auto form-group pb-2"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Time ", -1 /* HOISTED */)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_46 = { class: "input-group flex-nowrap" }
const _hoisted_47 = ["value"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "w-10" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_52 = { class: "form-group form-check custom-checkbox col-11 mt-2 ms-3 d-block d-md-flex" }
const _hoisted_53 = { class: "d-flex d-md-inline-block" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "schedule-without-time"
}, " Schedule Without Time ", -1 /* HOISTED */)
const _hoisted_55 = { class: "d-flex d-md-inline-block ms-md-5" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "override-shift-length"
}, " Override Shift Length ", -1 /* HOISTED */)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_58 = { class: "form-group col-10 col-md-3" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", null, "Recurrence", -1 /* HOISTED */)
const _hoisted_62 = ["value"]
const _hoisted_63 = ["value"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_65 = { class: "form-group col-6 col-md-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Repeat Until ", -1 /* HOISTED */)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_68 = { class: "input-group date datepickerInput" }
const _hoisted_69 = ["value"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_71 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_72 = { class: "form-group col-6 col-md-3" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_74 = { class: "form-group" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", null, "Repeat Every ", -1 /* HOISTED */)
const _hoisted_76 = ["value"]
const _hoisted_77 = ["value"]
const _hoisted_78 = { class: "form-group col-6 col-md-3" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", {
  for: "days",
  class: "mb-2"
}, " Repeat On ", -1 /* HOISTED */)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_81 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_83 = { class: "form-group col-6 col-md-3" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Repeat Until ", -1 /* HOISTED */)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_86 = { class: "input-group date datepickerInput" }
const _hoisted_87 = ["value"]
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_89 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_90 = { class: "form-group col-6 col-md-3" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", null, "Repeat Every ", -1 /* HOISTED */)
const _hoisted_94 = ["value"]
const _hoisted_95 = ["value"]
const _hoisted_96 = { class: "form-group col-6 col-md-3" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_98 = { class: "form-group" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", null, "Repeat Every ", -1 /* HOISTED */)
const _hoisted_100 = ["value"]
const _hoisted_101 = ["value"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_103 = { class: "form-group col-6 col-md-3" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_105 = { class: "form-group" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", null, "Repeat By ", -1 /* HOISTED */)
const _hoisted_107 = ["value"]
const _hoisted_108 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Day of Month", -1 /* HOISTED */)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("option", { value: 2 }, "Day of Week", -1 /* HOISTED */)
const _hoisted_110 = [
  _hoisted_108,
  _hoisted_109
]
const _hoisted_111 = { class: "form-group col-6 col-md-3" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Repeat Until ", -1 /* HOISTED */)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_114 = { class: "input-group date datepickerInput" }
const _hoisted_115 = ["value"]
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_117 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_119 = { class: "form-group col-12" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Select Days ", -1 /* HOISTED */)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_122 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_125 = { class: "form-group col-6 col-md-3" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Repeat Until ", -1 /* HOISTED */)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_128 = { class: "input-group date datepickerInput" }
const _hoisted_129 = ["value"]
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_131 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_132 = {
  key: 9,
  class: "w-100"
}
const _hoisted_133 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_134 = [
  _hoisted_133
]
const _hoisted_135 = {
  key: 10,
  class: "form-group col-10 col-md-6 col-lg-3"
}
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", { for: "client" }, " Client ", -1 /* HOISTED */)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_138 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_139 = {
  key: 11,
  class: "w-100"
}
const _hoisted_140 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_141 = [
  _hoisted_140
]
const _hoisted_142 = {
  key: 12,
  class: "form-group col-10 col-md-5 col-lg-3"
}
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", { for: "payment-source" }, " Payment Source ", -1 /* HOISTED */)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("option", { value: null }, "-- Select Payment Source --", -1 /* HOISTED */)
const _hoisted_146 = ["value"]
const _hoisted_147 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_148 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-100 mt-2" }, null, -1 /* HOISTED */)
const _hoisted_149 = [
  _hoisted_148
]
const _hoisted_150 = {
  key: 13,
  class: "form-group col-10 col-md-5 col-lg-3"
}
const _hoisted_151 = /*#__PURE__*/_createElementVNode("label", { for: "task" }, " Task ", -1 /* HOISTED */)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_153 = {
  key: 0,
  class: "multi-select-filter"
}
const _hoisted_154 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_155 = {
  key: 14,
  class: "form-group col-10 col-md-5 col-lg-3"
}
const _hoisted_156 = /*#__PURE__*/_createElementVNode("label", { for: "task" }, " Task ", -1 /* HOISTED */)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_158 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_160 = { class: "col-10 col-md-6 form-group" }
const _hoisted_161 = /*#__PURE__*/_createElementVNode("label", { for: "comments" }, " Comment ", -1 /* HOISTED */)
const _hoisted_162 = {
  key: 2,
  class: "d-flex justify-content-center my-2"
}
const _hoisted_163 = { key: 0 }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_165 = [
  _hoisted_164
]
const _hoisted_166 = {
  key: 1,
  class: "d-flex d-md-block justify-content-center flex-wrap-reverse flex-md-nowrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TimePicker = _resolveComponent("TimePicker")!
  const _component_DayPicker = _resolveComponent("DayPicker")!
  const _component_MultiDatePicker = _resolveComponent("MultiDatePicker")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_GroupDropdownSelect = _resolveComponent("GroupDropdownSelect")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_SaveNotifyUser = _resolveComponent("SaveNotifyUser")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "full-height": false,
    title: "Employee Scheduler",
    "application-id": _ctx.visitDetails.Application,
    "show-product-pill": true,
    "show-background": false
  }, {
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
        : (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isNva) = $event)),
                    value: false
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, _ctx.isNva]
                  ]),
                  _hoisted_8,
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isNva) = $event)),
                    value: true
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, _ctx.isNva]
                  ]),
                  _hoisted_9
                ]),
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.visitDetails.FirstName) + " " + _toDisplayString(_ctx.visitDetails.LastName), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", null, _toDisplayString(_ctx.visitDetails.AgencyName), 1 /* TEXT */)
                ])
              ]),
              (_ctx.isSingleDate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("input", {
                            id: "date",
                            name: "startDateTime",
                            type: "text",
                            placeholder: "MM/DD/YYYY",
                            autocomplete: "off",
                            value: _ctx.formatDateInput(_ctx.newVisitDetails.startDateTime.date),
                            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                            class: _normalizeClass(`form-control ${
                                        !_ctx.v$.newVisitDetails.startDateTime.date.$error ? '' : 'field-invalid mt-0'
                                    }`),
                            onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.startDateTime.date.$touch && _ctx.v$.newVisitDetails.startDateTime.date.$touch(...args)))
                          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_18),
                          _hoisted_19
                        ]),
                        (_ctx.v$.newVisitDetails.startDateTime.date.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Date is required."))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" Statement Range "),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("input", {
                                type: "text",
                                name: "startDateTime",
                                placeholder: "MM/DD/YYYY",
                                value: _ctx.formatDateInput(_ctx.newVisitDetails.startDateTime.date),
                                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                                class: _normalizeClass(`form-control rounded-0 border-end-0 ${
                                            !_ctx.v$.newVisitDetails.startDateTime.date.$error ? '' : 'field-invalid mt-0'
                                        }`),
                                onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.startDateTime.date.$touch && _ctx.v$.newVisitDetails.startDateTime.date.$touch(...args)))
                              }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_26),
                              _hoisted_27
                            ]),
                            (_ctx.v$.newVisitDetails.startDateTime.date.$error)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Start Date is required."))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["getDate"]),
                        _hoisted_29,
                        _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("input", {
                                disabled: "",
                                type: "text",
                                name: "endDateTime",
                                class: "form-control rounded-0 border-end-0",
                                placeholder: "MM/DD/YYYY",
                                value: _ctx.formatDateInput(_ctx.newVisitDetails.endDateTime.date),
                                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                                "date-format-only": ""
                              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_31),
                              _hoisted_32
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["getDate"])
                      ])
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedBranch) = $event)),
                      onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.selectedBranch.id.$touch && _ctx.v$.selectedBranch.id.$touch(...args)))
                    }, [
                      _hoisted_35,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedBranches, (branch) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: branch,
                          key: branch.name
                        }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_36))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                      [_vModelSelect, _ctx.selectedBranch]
                    ]),
                    (_ctx.v$.selectedBranch?.id?.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Branch is required."))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.shiftLength) = $event)),
                  disabled: _ctx.scheduleWithoutTime || _ctx.overrideShiftLength
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                    return _createElementVNode("option", { value: i }, _toDisplayString(i) + " " + _toDisplayString(i === 1 ? "Hour" : "Hours"), 9 /* TEXT, PROPS */, _hoisted_42)
                  }), 64 /* STABLE_FRAGMENT */))
                ], 8 /* PROPS */, _hoisted_41), [
                  [_vModelSelect, _ctx.shiftLength]
                ])
              ]),
              (!_ctx.scheduleWithoutTime)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _hoisted_45,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_TimePicker, { onUpdateProps: _ctx.changeStartTime }, {
                          default: _withCtx(() => [
                            _createElementVNode("input", {
                              placeholder: "hh:mm AM",
                              type: "text",
                              autocomplete: "off",
                              maxlength: "8",
                              value: _ctx.newVisitDetails.startDateTime.time,
                              class: _normalizeClass(`form-control ${
                                            !_ctx.v$.newVisitDetails.startDateTime.time.$error ? '' : 'field-invalid mt-0'
                                        }`),
                              onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.startDateTime.time.$touch && _ctx.v$.newVisitDetails.startDateTime.time.$touch(...args)))
                            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_47)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onUpdateProps"]),
                        _hoisted_48,
                        _createVNode(_component_TimePicker, {
                          onUpdateProps: _ctx.changeEndTime,
                          id: "schedule-hc-task-end-time"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              placeholder: "hh:mm AM",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              maxlength: "8",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newVisitDetails.endDateTime.time) = $event)),
                              disabled: !_ctx.overrideShiftLength
                            }, null, 8 /* PROPS */, _hoisted_49), [
                              [_vModelText, _ctx.newVisitDetails.endDateTime.time]
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onUpdateProps"])
                      ]),
                      (_ctx.v$.newVisitDetails.startDateTime.time.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, " Time is required. "))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "schedule-without-time",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.scheduleWithoutTime) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.scheduleWithoutTime]
                  ]),
                  _hoisted_54
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "override-shift-length",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.overrideShiftLength) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.overrideShiftLength]
                  ]),
                  _hoisted_56
                ])
              ]),
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("select", {
                    class: "form-select",
                    value: _ctx.newVisitDetails.recurrence.type,
                    onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleRecurrenceChange && _ctx.handleRecurrenceChange(...args))),
                    name: "recurrence"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.recurrenceType), ([key, value]) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: key,
                        value: value.value
                      }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_63))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_62)
                ])
              ]),
              _createCommentVNode(" Daily "),
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.Daily)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _hoisted_64,
                    _createElementVNode("div", _hoisted_65, [
                      _hoisted_66,
                      _hoisted_67,
                      _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("input", {
                              id: "date",
                              name: "endDate",
                              type: "text",
                              placeholder: "Select Date",
                              "date-format-only": "",
                              value: _ctx.formatDateInput(_ctx.newVisitDetails.recurrence.endDate),
                              onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                              class: _normalizeClass(`form-control ${
                                            !_ctx.v$.newVisitDetails.recurrence.endDate.$error ? '' : 'field-invalid mt-0'
                                        }`),
                              onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.recurrence.endDate.$touch && _ctx.v$.newVisitDetails.recurrence.endDate.$touch(...args)))
                            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_69),
                            _hoisted_70
                          ]),
                          (_ctx.v$.newVisitDetails.recurrence.endDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_71, "Repeat Until Date is required."))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _createElementVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _createElementVNode("select", {
                          class: "form-select",
                          value: _ctx.newVisitDetails.recurrence.repeatNumber,
                          name: "repeat-every"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (i) => {
                            return _createElementVNode("option", { value: i }, _toDisplayString(i) + " " + _toDisplayString(i == 1 ? "day" : "days"), 9 /* TEXT, PROPS */, _hoisted_77)
                          }), 64 /* STABLE_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_76)
                      ])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Weekly "),
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.Weekly)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _createElementVNode("div", _hoisted_78, [
                      _hoisted_79,
                      _hoisted_80,
                      _createVNode(_component_DayPicker, {
                        "selected-days-string": _ctx.newVisitDetails.recurrence.daysOfWeek,
                        onUpdateSelectedDays: _ctx.updateDaysOfWeek
                      }, null, 8 /* PROPS */, ["selected-days-string", "onUpdateSelectedDays"]),
                      (_ctx.v$.newVisitDetails.recurrence.daysOfWeek.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_81, "Repeat on Date is required."))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, [
                      _hoisted_84,
                      _hoisted_85,
                      _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("input", {
                              id: "date",
                              type: "text",
                              name: "endDate",
                              placeholder: "Select Date",
                              "date-format-only": "",
                              value: _ctx.formatDateInput(_ctx.newVisitDetails.recurrence.endDate),
                              onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                              class: _normalizeClass(`form-control ${
                                            !_ctx.v$.newVisitDetails.recurrence.endDate.$error ? '' : 'field-invalid mt-0'
                                        }`),
                              onBlur: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.recurrence.endDate.$touch && _ctx.v$.newVisitDetails.recurrence.endDate.$touch(...args)))
                            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_87),
                            _hoisted_88
                          ]),
                          (_ctx.v$.newVisitDetails.recurrence.endDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_89, "Repeat Until Date is required."))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_90, [
                      _hoisted_91,
                      _createElementVNode("div", _hoisted_92, [
                        _hoisted_93,
                        _createElementVNode("select", {
                          class: "form-select",
                          value: _ctx.newVisitDetails.recurrence.repeatNumber,
                          name: "repeat-every"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (i) => {
                            return _createElementVNode("option", { value: i }, _toDisplayString(i) + " " + _toDisplayString(i == 1 ? "week" : "weeks"), 9 /* TEXT, PROPS */, _hoisted_95)
                          }), 64 /* STABLE_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_94)
                      ])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Monthly "),
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.Monthly)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    _createElementVNode("div", _hoisted_96, [
                      _hoisted_97,
                      _createElementVNode("div", _hoisted_98, [
                        _hoisted_99,
                        _createElementVNode("select", {
                          class: "form-select",
                          value: _ctx.newVisitDetails.recurrence.repeatNumber,
                          name: "repeat-every"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (i) => {
                            return _createElementVNode("option", { value: i }, _toDisplayString(i) + " " + _toDisplayString(i == 1 ? "month" : "months"), 9 /* TEXT, PROPS */, _hoisted_101)
                          }), 64 /* STABLE_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_100)
                      ])
                    ]),
                    _hoisted_102,
                    _createElementVNode("div", _hoisted_103, [
                      _hoisted_104,
                      _createElementVNode("div", _hoisted_105, [
                        _hoisted_106,
                        _createElementVNode("select", {
                          class: "form-select",
                          value: _ctx.newVisitDetails.recurrence.repeatBy,
                          name: "repeat-every"
                        }, _hoisted_110, 8 /* PROPS */, _hoisted_107)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_111, [
                      _hoisted_112,
                      _hoisted_113,
                      _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("input", {
                              id: "date",
                              type: "text",
                              name: "endDate",
                              placeholder: "Select Date",
                              "date-format-only": "",
                              value: _ctx.formatDateInput(_ctx.newVisitDetails.recurrence.endDate),
                              onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                              class: _normalizeClass(`form-control ${
                                            !_ctx.v$.newVisitDetails.recurrence.endDate.$error ? '' : 'field-invalid mt-0'
                                        }`),
                              onBlur: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.recurrence.endDate.$touch && _ctx.v$.newVisitDetails.recurrence.endDate.$touch(...args)))
                            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_115),
                            _hoisted_116
                          ]),
                          (_ctx.v$.newVisitDetails.recurrence.endDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_117, "Repeat Until Date is required."))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Flexible "),
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.Flexible)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                    _hoisted_118,
                    _createElementVNode("div", _hoisted_119, [
                      _hoisted_120,
                      _hoisted_121,
                      _createVNode(_component_MultiDatePicker, {
                        result: _ctx.visitDates,
                        onUpdateResult: _ctx.updateResult
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            class: _normalizeClass(`form-control ${
                                        !_ctx.v$.newVisitDetails.recurrence.flexibleDates.$error ? '' : 'field-invalid mt-0'
                                    }`),
                            onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.recurrence.flexibleDates.$touch && _ctx.v$.newVisitDetails.recurrence.flexibleDates.$touch(...args)))
                          }, null, 34 /* CLASS, HYDRATE_EVENTS */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["result", "onUpdateResult"]),
                      (_ctx.v$.newVisitDetails.recurrence.flexibleDates.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_122, "Dates are required."))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _hoisted_123
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" 60 days "),
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.SixtyDays)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                    _hoisted_124,
                    _createElementVNode("div", _hoisted_125, [
                      _hoisted_126,
                      _hoisted_127,
                      _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_128, [
                            _createElementVNode("input", {
                              id: "date",
                              type: "text",
                              name: "endDate",
                              placeholder: "Select Date",
                              "date-format-only": "",
                              value: _ctx.formatDateInput(_ctx.newVisitDetails.recurrence.endDate),
                              onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handleDateInputChange && _ctx.handleDateInputChange(...args))),
                              class: _normalizeClass(`form-control ${
                                            !_ctx.v$.newVisitDetails.recurrence.endDate.$error ? '' : 'field-invalid mt-0'
                                        }`),
                              onBlur: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.recurrence.endDate.$touch && _ctx.v$.newVisitDetails.recurrence.endDate.$touch(...args)))
                            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_129),
                            _hoisted_130
                          ]),
                          (_ctx.v$.newVisitDetails.recurrence.endDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_131, "Repeat Until Date is required."))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" End of recurrence "),
              (!_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_132, _hoisted_134))
                : _createCommentVNode("v-if", true),
              (!_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                    _hoisted_136,
                    _hoisted_137,
                    _createVNode(_component_TypeaheadInput, {
                      id: "client",
                      getData: _ctx.clientListFilter,
                      value: _ctx.client,
                      onValueChanged: _ctx.clientChanged,
                      placeholder: "Type to Select User",
                      "show-all-by-default": true,
                      "open-on-focus": true,
                      ref: "typeAheadRefClient",
                      onBlurredInput: _ctx.v$.client?.$touch,
                      class: _normalizeClass(`${!_ctx.v$.client?.$error ? '' : 'field-invalid'}`)
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlurredInput", "class"]),
                    (_ctx.v$.client?.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_138, "Client is required."))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_139, _hoisted_141))
                : _createCommentVNode("v-if", true),
              (!_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                    _hoisted_143,
                    _hoisted_144,
                    _withDirectives(_createElementVNode("select", {
                      id: "payment-source",
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newVisitDetails.payorId) = $event)),
                      class: _normalizeClass(`form-select ${!_ctx.v$.newVisitDetails.payorId.$error ? '' : 'field-invalid mt-0'}`),
                      onBlur: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.payorId.$touch && _ctx.v$.newVisitDetails.payorId.$touch(...args)))
                    }, [
                      _hoisted_145,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payorList, (payor) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: payor.insuranceId
                        }, _toDisplayString(payor.name) + " (" + _toDisplayString(payor.typeName) + ") ", 9 /* TEXT, PROPS */, _hoisted_146))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 34 /* CLASS, HYDRATE_EVENTS */), [
                      [_vShow, !_ctx.isPaymentSourceLoading],
                      [_vModelSelect, _ctx.newVisitDetails.payorId]
                    ]),
                    (_ctx.v$.newVisitDetails.payorId.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_147, "Payment Source is required."))
                      : _createCommentVNode("v-if", true),
                    _withDirectives(_createElementVNode("div", null, _hoisted_149, 512 /* NEED_PATCH */), [
                      [_vShow, _ctx.isPaymentSourceLoading]
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (!_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                    _hoisted_151,
                    _hoisted_152,
                    (!!_ctx.taskDropdownSelectOptions)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                          _createVNode(_component_GroupDropdownSelect, {
                            "drop-down-options": _ctx.taskDropdownSelectOptions,
                            "label-text": "Task",
                            "selected-value": _ctx.newVisitDetails.customNoteId,
                            "selected-text": _ctx.newVisitDetails.taskName,
                            "selected-id": _ctx.newVisitDetails.disciplineTask,
                            onUpdateSelectFields: _ctx.updateSelectFields,
                            class: _normalizeClass(` ${!_ctx.v$.newVisitDetails.disciplineTask.$error ? '' : 'field-invalid mt-0'}`),
                            onBlur: _ctx.v$.newVisitDetails.disciplineTask.$touch
                          }, null, 8 /* PROPS */, ["drop-down-options", "selected-value", "selected-text", "selected-id", "onUpdateSelectFields", "class", "onBlur"]),
                          (_ctx.v$.newVisitDetails.disciplineTask.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_154, "Task is required."))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.isNva)
                ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                    _hoisted_156,
                    _hoisted_157,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.nvaAvailableTasksFilter,
                      value: _ctx.nvaActivity,
                      onValueChanged: _ctx.nvaActivityChanged,
                      "show-all-by-default": true,
                      "open-on-focus": true,
                      "must-select-value": true,
                      placeholder: "Type to Filter Task",
                      onBlurredInput: _ctx.v$.nvaActivity.$touch,
                      class: _normalizeClass(`${!_ctx.v$.nvaActivity?.$error ? '' : 'field-invalid'}`)
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "onBlurredInput", "class"]),
                    (_ctx.v$.nvaActivity?.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_158, "Activity is required."))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              _hoisted_159,
              _createElementVNode("div", _hoisted_160, [
                _hoisted_161,
                _createVNode(_component_CommentInput, {
                  id: "comments",
                  "input-name": "nonadmit-comments",
                  "show-template-typeahead": false,
                  "comment-required": false,
                  result: _ctx.newVisitDetails.comments,
                  "max-length": 1000,
                  onResultUpdated: _ctx.resultUpdated
                }, null, 8 /* PROPS */, ["result", "onResultUpdated"])
              ])
            ])
          ])),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
            (_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("div", _hoisted_163, _hoisted_165))
              : (_openBlock(), _createElementBlock("div", _hoisted_166, [
                  _createElementVNode("button", {
                    class: "btn btn-primary my-1 my-md-0",
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndExit)))
                  }, " Save and Exit "),
                  _createVNode(_component_SaveNotifyUser, {
                    "agency-id": _ctx.newVisitDetails.agencyId,
                    "button-name": "Save and Notify Employee",
                    onHandleSaveVisit: _cache[27] || (_cache[27] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndNotifyEmployee)))
                  }, null, 8 /* PROPS */, ["agency-id"]),
                  _createElementVNode("button", {
                    class: "btn btn-primary my-1 my-md-0 mx-2",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndAddAnother)))
                  }, " Save and Add Another "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-md btn-outline-secondary my-1 my-md-0",
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.cancel()))
                  }, " Cancel ")
                ]))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}